/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendOpexVariantResponseDto } from '../../models/backend-opex-variant-response-dto';

export interface OpexesVariantsList$Params {
  is_blocked?: boolean;
  product_varinat?: number;

  /**
   * Фильтр по проекту
   */
  project: number;
  variant_name?: string;
}

export function opexesVariantsList(
  http: HttpClient,
  rootUrl: string,
  params: OpexesVariantsList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<Array<BackendOpexVariantResponseDto>>> {
  const rb = new RequestBuilder(rootUrl, opexesVariantsList.PATH, 'get');
  if (params) {
    rb.query('is_blocked', params.is_blocked, {});
    rb.query('product_varinat', params.product_varinat, {});
    rb.query('project', params.project, {});
    rb.query('variant_name', params.variant_name, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<Array<BackendOpexVariantResponseDto>>;
    }),
  );
}

opexesVariantsList.PATH = '/api/opexes/variants/';
